'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StarHalf;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function StarHalf(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$strokeColor = _ref.strokeColor,
      strokeColor = _ref$strokeColor === undefined ? 'currentColor' : _ref$strokeColor;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-star-half ' + className, width: width, height: height, viewBox: '0 0 16 16' },
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { fill: color, fillRule: 'nonzero', d: 'M16,6.21200001 L10.472,5.40900001 L8,0.400000006 L5.528,5.40900001 L0,6.21200001 L4,10.111 L3.056,15.616 L8,13.017 L12.944,15.616 L12,10.111 L16,6.21200001 Z M8,12.3770234 L7.985,11.789 L8,2.21956464 L10.0358433,6.09733988 L14.4722466,6.78667448 L11.2286233,9.85690966 L11.9948141,14.1685241 L8,12.2810092 L8,12.3770234 Z' }),
      _react2.default.createElement('path', { fill: 'none', stroke: strokeColor, strokeWidth: '.9', d: 'M15.1941029,6.47387071 L10.222977,5.75176252 L8,1.24735641 L5.77702298,5.75176252 L0.805897078,6.47387071 L4.40292492,9.9800736 L3.55401651,14.9305405 L8,12.5933417 L12.4459835,14.9305405 L11.5970751,9.9800736 L15.1941029,6.47387071 Z' })
    )
  );
}

StarHalf.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/StarHalf/StarHalf.js
// module id = 343
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16